import { Buffer } from 'buffer';
import formFileChild from '@/models/enrollment/formFileChild';

export default class fileModel {
    public file: Blob | null = null;
    public base64: string | null = null;
}

const base64toBlob = (base64Data: string, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});

    return blob;
}

const base64ToFile = (url: string, filename: string, mimeType: string) =>
{
    const buff = Buffer.from(url, 'base64');

    return new File([buff], filename, { type: mimeType });
}

const cloneFile = async (file: File) =>
{
    let res: File;
    
    if (file) {
        const buffer: any = await (file as any).arrayBuffer();

        res = new File([buffer], file.name, { type: file.type });
    }
    else {
        res = file;
    }

    return(res);
}

const fileToArrayBuffer = (file: any) =>
{
    if ((file === null) || (file === undefined))
    {
        return("");
    }
    
    // Returns a promise which gets resolved or rejected based on the reader events
    return new Promise((resolve, reject) =>
    {
        const reader = new FileReader();

        // Sets up even listeners BEFORE you call reader.readAsArrayBuffer
        reader.onload = function()
        {         
            const result = reader.result

            return resolve(result);
        };
    
        reader.onerror = function (error)
        {            
            return reject(error);
        };

        // Calls reader function
        reader.readAsArrayBuffer(file);
    });
}

const fileToBase64 = (file: any) =>
{
    if ((file === null) || (file === undefined) || (file && (file.size == 0)))
    {
        return("");
    }
    
    // Returns a promise which gets resolved or rejected based on the reader events
    return new Promise((resolve, reject) =>
    {
        const reader = new FileReader();

        // Sets up even listeners BEFORE you call reader.readAsDataURL
        reader.onload = function()
        {         
            const result = reader.result

            return resolve(result);
        };
    
        reader.onerror = function (error)
        {            
            return reject(error);
        };

        // Calls reader function
        reader.readAsDataURL(file);
    });
}

const fileToBinaryString = (file: any) =>
{
    if ((file === null) || (file === undefined))
    {
        return("");
    }
    
    // Returns a promise which gets resolved or rejected based on the reader events
    return new Promise((resolve, reject) =>
    {
        const reader = new FileReader();

        // Sets up even listeners BEFORE you call reader.readAsBinaryString
        reader.onload = function()
        {         
            const result = reader.result

            return resolve(result);
        };
    
        reader.onerror = function (error)
        {            
            return reject(error);
        };

        // Calls reader function
        reader.readAsBinaryString(file);
    });
}

const formFileChildToFileModel = (formFileChild: formFileChild) =>
{
    let res: fileModel = new fileModel();

    res.file = formFileChildToFile(formFileChild);
    res.base64 = formFileChildToBase64(formFileChild);

    return(res);
}

const formFileChildToFile = (formFileChild: formFileChild) =>
{
    let res: File | null;

    if (formFileChild) {
        let url: string = formFileChild.binaryData;
        let filename: string = formFileChild.fileName;
        let mimeType: string = formFileChild.contentType;
    
        res = base64ToFile(url, filename, mimeType);	
    }
    else {
        res = null;
    }

    return(res);
}

const formFileChildToBase64 = (formFileChild: formFileChild) =>
{
    let res: string | null = null;

    if (formFileChild) {
        res = plainTextToBase64(formFileChild.binaryData, formFileChild.contentType);
    }

    return(res);
}

const plainTextToBase64 = (plainText: string | null, contentType: string | null) =>
{
    let res: string | null = null;

    if (plainText) {
        if (contentType) {
            switch ((contentType as any).toLowerCase()) {
                case 'application/pdf':
                    res = "data:@file/pdf;base64,";

                    break;
                case 'image/jpeg':
                    res = "data:image/jpeg;charset=utf-8;base64,";
                    
                    break;
                default:
                    res = "";

                    break;
            }
        }

        res = res + plainText;
    }

    return(res);
}

const filesToFormData = (files: Array<File> | null) =>
{
    let res = new FormData();

    if (files) {
        files.forEach(file => {
            res.append("files", file);
        });
    }

    return(res);
}

const chatFilesToFormData = (files: Array<any> | null) =>
{
    let res = new FormData();    
    
    //files
    if (files) {
      (files as any).forEach((fileData: any) => {
        let fileName = fileData.name + (fileData.extension ? ('.' + fileData.extension) : '');
        let file = new File([fileData.blob], fileName, { type: fileData.type })

        res.append("files", file);
      });
    }

    return(res);
}

export
{
    fileModel,
    base64toBlob,
    base64ToFile,
    cloneFile,
    fileToArrayBuffer,
    fileToBase64,    
    fileToBinaryString,
    formFileChildToBase64,
    formFileChildToFile,
    formFileChildToFileModel,
    plainTextToBase64,
    filesToFormData,
    chatFilesToFormData
}